import { network } from "../network/network.js";
const endpoint = "/consents";
export async function toggleConsents(...consents) {
    return await network(endpoint, {
        method: "POST",
        json: consents,
    });
}
